import {SearchByListParameter} from "./SearchByListParameter";

export class ListoutByListParameter {
  constructor(
    public searchByListParameter?:SearchByListParameter,
    public changeExpirationProduct?: boolean,
    public expirationProductToSet?: boolean,
    public expirationProductDateToSet?: Date,
    public newProductStatusText?:[string]
  ) { }
}
